import { Dialog } from 'primereact/dialog'
import React from 'react'
import { LocationConfirmDialogProps } from '../../types/inventory'
import { Button } from 'primereact/button'
import { useNavigate } from 'react-router-dom'
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

const LocationConfirmDialog = (props: LocationConfirmDialogProps) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const onClickMove = (path: string) => {
        navigate(path, { state: { lctSeq: props.lctSeq } })
    }

    const footer = () => {
        return (
            <>
                <div className="grid">
                    <div className="col-6">
                        <Button
                            className="w-full p-button-secondary mt-4"
                            label={t(tokens.common.close)}
                            size="large"
                            onClick={() => onClickMove('location-detail')}
                        />
                    </div>
                    <div className="col-6">
                        <Button
                            className="w-full p-button-info mt-4 col-6"
                            label={t(tokens.common.additional_registration)}
                            size="large"
                            onClick={() => onClickMove('location-regist')}
                        />
                    </div>
                </div>
            </>
        )
    }
    return (
        <>
            <Dialog
                header={t(tokens.common.success)}
                visible={props.visible}
                onHide={() => props.onHide()}
                closable={false}
                contentClassName="pb-0"
                footer={footer}
                style={{ width: '60vh' }}
            >
                <div className="font-bold text-lg">
                    <div>{t(tokens.inventory.location_registration_completed)}</div>
                    <div>{t(tokens.inventory.confirm_additional_registration)}</div>
                </div>
            </Dialog>
        </>
    )
}

export default LocationConfirmDialog
